import React from 'react';
import { Mail, RefreshCw, Globe2 } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export const Problem = () => {
  const useCases = [{
    icon: <Mail className="text-zano-pink" size={24} data-id="element-2022" data-mp="2pdecrg845jth" />,
    title: 'Reach the talent you want, instantly',
    desc: "Have an A-list creator or celebrity in mind? Search their name in Zano and get their talent manager's direct email right away — you're one message from a conversation."
  }, {
    icon: <RefreshCw className="text-blue-500" size={24} data-id="element-2023" data-mp="21o3a1t77dfcp" />,
    title: 'Live rosters from your agency partners',
    desc: 'For the agencies you already partner with, their rosters and performance data stay live in Zano — kept current by the agencies themselves, with performance and audience data built in and ready at a glance.'
  }, {
    icon: <Globe2 className="text-purple-500" size={24} data-id="element-2024" data-mp="1is3iukm1ufu6" />,
    title: 'Source from team-vetted agencies worldwide',
    desc: 'Every agency is personally vetted by our team — we meet with them before they can create an account and check in regularly. Discover hundreds of verified agencies and their represented creators across the US, UK, Europe, Asia, and the UAE.'
  }];
  return <section className="py-24 bg-white" data-id="element-2025" data-mp="12av6xpvwkhly">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2026" data-mp="128iufs8wyzga">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-2027" data-mp="xclevo5h5x4k">
          <h2 className="text-3xl md:text-4xl font-bold text-zano-charcoal mb-4" data-id="element-2028" data-mp="9locp33hee6i">
            A live, breathing database of represented talent
          </h2>
          <p className="text-lg text-gray-600" data-id="element-2029" data-mp="5lxbs6k8qho9">
            Unlike traditional influencer platforms that index creators, Zano
            connects you directly to the talent agencies that represent them —
            with agencies adding and managing their own live roster profiles.
          </p>
          <p className="mt-4 text-base text-gray-500" data-id="element-2030" data-mp="3mz9kqaujp9r8">
            Talent agencies often update who they represent. Zano turns those
            constantly changing rosters into one live discovery network for
            brands.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2031" data-mp="1qx63yykjhdye">
          {useCases.map((point, idx) => <Reveal key={idx} delay={idx * 0.08} className="h-full" data-id="element-2032" data-mp="1vo638ah4s842" data-mpi={idx}>
              <div className="h-full bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-zano-pink/40 hover:shadow-float hover:-translate-y-1 transition-all duration-300" data-id="element-2033" data-mp="20nixvhe8ujh7">
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center mb-4 border border-gray-100" data-id="element-2034" data-mp="1323gatxh1gji">
                  {point.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2035" data-mp="1d013rf7ib9b2">
                  {point.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-2036" data-mp="2od3h81eb7ir0">
                  {point.desc}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
};